/**
 * STYLING: Plain Tailwind ONLY!
 * One-click refine pills shown below a generation result.
 */

import { useTranslation } from 'react-i18next';
import { EID } from '@/lib/element-ids.registry';
import type { RefineIntent } from './textGenerationApi';

const INTENTS: RefineIntent[] = [
  'shorter',
  'longer',
  'casual',
  'formal',
  'with_hashtags',
  'new_hook',
];

const EID_BY_INTENT: Record<RefineIntent, keyof typeof EID> = {
  shorter: 'text-tool-refine-shorter-btn',
  longer: 'text-tool-refine-longer-btn',
  casual: 'text-tool-refine-casual-btn',
  formal: 'text-tool-refine-formal-btn',
  with_hashtags: 'text-tool-refine-with_hashtags-btn',
  new_hook: 'text-tool-refine-new_hook-btn',
};

interface Props {
  onRefine: (intent: RefineIntent) => void;
  refining: boolean;
}

export function TextToolRefineBar({ onRefine, refining }: Props) {
  const { t } = useTranslation();
  return (
    <div className="text-tool-refine-bar border-t border-neutral-200 dark:border-neutral-700 pt-3">
      <p className="text-xs font-medium text-neutral-600 dark:text-neutral-400 mb-2">
        {refining ? t('textTools.refine.running') : t('textTools.refine.title')}
      </p>
      <div className="flex flex-wrap gap-2">
        {INTENTS.map((intent) => (
          <button
            key={intent}
            id={EID[EID_BY_INTENT[intent]]}
            type="button"
            disabled={refining}
            onClick={() => onRefine(intent)}
            className="px-3 py-1.5 text-xs rounded-full border border-neutral-300 dark:border-neutral-600 text-neutral-700 dark:text-neutral-300 hover:border-primary-400 hover:bg-primary-50 dark:hover:bg-primary-950/30 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {t(`textTools.refine.${intent}`)}
          </button>
        ))}
      </div>
    </div>
  );
}
